import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { palette } from 'c1ui'

export const dateSelectStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.border.primary,
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after, & .MuiInput-underline:hover:not(.Mui-disabled):before':
                {
                    border: 'none',
                },
            '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.error.main,
                '& .Mui-focused fieldset': {
                    border: 'none',
                },
            },
            '& .MuiInputBase-root': {
                background: palette.background.default,
            },
            '& .MuiInputBase-input': {
                padding: theme.spacing(2),
            },
        },
    })
})
